import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, Scroll } from '@angular/router';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { BreadCrumb } from './bread-crumb';
import { CommonModule } from '@angular/common';


@Component({
	selector: 'gp-bread-crumb',
	templateUrl: './bread-crumb.component.html',
	styleUrls: ['./bread-crumb.component.scss'],
	imports: [CommonModule, RouterModule],
	standalone: true,
	encapsulation: ViewEncapsulation.None
})
export class BreadCrumbComponent implements OnInit, OnDestroy {

	HOME = 'Home';

	public breadcrumbs: BreadCrumb[] = [];
	private isDestroyed$: Subject<void> = new Subject<void>();

	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router
	) { }

	ngOnInit(): void {
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd ||
				(event instanceof Scroll && event.routerEvent instanceof NavigationEnd)),
			distinctUntilChanged(),
			takeUntil(this.isDestroyed$)
		).subscribe(() => {
			this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
		});
	}

	ngOnDestroy(): void {
		this.isDestroyed$.next();
		this.isDestroyed$.complete();
	}

	private createBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs: BreadCrumb[] = []): BreadCrumb[] {
		const children: ActivatedRoute[] = route.children;

		if (children.length === 0) {
			return breadcrumbs;
		}

		for (const child of children) {
			const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
			if (routeURL !== '') {
				url += `/${routeURL}`;
			}

			breadcrumbs.push({ label: child.snapshot.data['breadcrumb'], url: url });
			return this.createBreadcrumbs(child, url, breadcrumbs);
		}
		return breadcrumbs;
	}
}
